import React, { useState } from 'react';
import { APP_COLORS as C, APP_FONT as F } from '../tokens';
import { fmtMoney } from '../helpers';
import type { CashFlowPoint } from '../types';
import CashFlowArea from './CashFlowArea';
import CashFlowBars from './CashFlowBars';

type Mode = 'balance' | 'flow';

type Props = {
  points: ReadonlyArray<CashFlowPoint>;
  todayCashBalance: number;
  threshold?: number;
  startingBalance?: number;
  onViewDetail?: () => void;
};

export default function CashFlowCard({
  points,
  todayCashBalance,
  threshold = 0,
  startingBalance = 0,
  onViewDetail,
}: Props) {
  const [mode, setMode] = useState<Mode>('balance');

  const toggleBtn = (m: Mode, label: string) => (
    <label
      onClick={() => setMode(m)}
      style={{
        padding: '6px 12px',
        borderRadius: 5,
        cursor: 'pointer',
        color: mode === m ? C.ink : C.sub,
        background: mode === m ? '#fff' : 'transparent',
        boxShadow: mode === m ? '0 1px 2px rgba(0,0,0,0.08)' : 'none',
      }}
    >
      {label}
    </label>
  );

  return (
    <div style={{
      background: C.card,
      border: '1px solid ' + C.line,
      borderRadius: 14,
      padding: '20px 22px',
      fontFamily: F.family,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
        <h3 style={{ fontSize: 14, fontWeight: 700, margin: 0 }}>Cash flow</h3>
        <span onClick={onViewDetail} style={{ fontSize: 12, color: C.tealInk, fontWeight: 700, cursor: 'pointer' }}>
          View cash flow
        </span>
      </div>

      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 10, gap: 10 }}>
        <div>
          <div style={{ fontSize: 11, color: C.sub, fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase', marginBottom: 4 }}>
            Today's cash balance
          </div>
          <div style={{ fontSize: 26, fontWeight: 800, color: C.ink, letterSpacing: '-0.015em', fontVariantNumeric: 'tabular-nums' }}>
            {fmtMoney(todayCashBalance)}
          </div>
        </div>

        <div style={{
          display: 'inline-flex', background: C.page, borderRadius: 8,
          padding: 3, fontSize: 12, fontWeight: 600,
        }}>
          {toggleBtn('balance', 'Cash balance')}
          {toggleBtn('flow', 'Money in/out')}
        </div>
      </div>

      {mode === 'balance' ? (
        <CashFlowArea points={points} threshold={threshold} startingBalance={startingBalance} />
      ) : (
        <CashFlowBars points={points} />
      )}
    </div>
  );
}
